import "core-js/modules/es.symbol";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.keys";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import classNames from 'classnames';
import { AlignTarget } from "../Align";
import { PressableCore } from "./";

var PressableField = function PressableField(props) {
  var getColor = function getColor() {
    var disabled = props.disabled,
        hovered = props.hovered;

    if (disabled) {
      return 'disabled';
    }

    return hovered ? 'hover' : 'default';
  };

  var getCursor = function getCursor() {
    var disabled = props.disabled;
    return disabled ? 'default' : 'text';
  };

  var getFill = function getFill() {
    var disabled = props.disabled,
        ghost = props.ghost;
    var fillColor = disabled ? 'disabled' : 'base';
    return ghost ? 'none' : fillColor;
  };

  var getFontLineHeight = function getFontLineHeight() {
    var size = props.size;

    if (size === 'jumbo') {
      return 28;
    } else if (size === 'large') {
      return 20;
    } else if (size === 'small') {
      return 16;
    }

    return 20;
  };

  var getFontSize = function getFontSize() {
    var size = props.size;

    if (size === 'small') {
      return 13;
    } else if (size === 'jumbo') {
      return 16;
    }

    return 14;
  };

  var getKeyline = function getKeyline() {
    var disabled = props.disabled,
        ghost = props.ghost,
        invalid = props.invalid;
    var keylineColor = !disabled && invalid ? 'negative' : 'base';
    return ghost ? 'none' : {
      color: keylineColor,
      side: 'all',
      width: 1
    };
  };

  var getPadding = function getPadding() {
    var padding = props.padding,
        size = props.size;

    if (padding) {
      return padding;
    } else if (size === 'jumbo') {
      return {
        horizontal: 16,
        vertical: 8
      };
    } else if (size === 'large') {
      return {
        horizontal: 12,
        vertical: 8
      };
    }

    return {
      horizontal: 8,
      vertical: 4
    };
  };

  var getShadow = function getShadow() {
    var disabled = props.disabled,
        focused = props.focused,
        ghost = props.ghost;
    return ghost ? {
      focused: !disabled && focused
    } : {
      base: true,
      focused: !disabled && focused
    };
  };

  var children = props.children,
      className = props.className,
      disabled = props.disabled,
      display = props.display,
      focused = props.focused,
      ghost = props.ghost,
      hovered = props.hovered,
      invalid = props.invalid,
      padding = props.padding,
      radius = props.radius,
      size = props.size,
      width = props.width,
      remaining = _objectWithoutProperties(props, ["children", "className", "disabled", "display", "focused", "ghost", "hovered", "invalid", "padding", "radius", "size", "width"]);

  var classes = classNames('PressableField', className);
  return /*#__PURE__*/React.createElement(AlignTarget, {
    lineHeight: getFontLineHeight(),
    nestable: true,
    size: getFontSize(),
    strategy: "center",
    padding: getPadding()
  }, function (alignProps) {
    return (
      /*#__PURE__*/
      // $FlowFixMe - go/flowfixme122
      React.createElement(PressableCore, _extends({}, alignProps, remaining, {
        className: classes,
        color: getColor(),
        cursor: getCursor(),
        display: display,
        fill: getFill(),
        fontLineHeight: getFontLineHeight(),
        fontSize: getFontSize(),
        height: size,
        keyline: getKeyline(),
        padding: getPadding(),
        radius: radius,
        shadow: getShadow(),
        width: width
      }), children)
    );
  });
};

PressableField.defaultProps = {
  disabled: false,
  display: 'inline-flex',
  focused: false,
  ghost: false,
  hovered: false,
  invalid: false,
  radius: 'all',
  size: 'medium',
  width: 'auto'
};
export default PressableField;